<template>
  <div>
    <PerformanceUser ref="performanceUser" />
    <Expedition ref="expedition" />
    <HistoryRetur ref="historyRetur" />
    <ChartTransaction ref="chartTransaction" />
  </div>
</template>

<script>
import { toastError } from '@/views/pages/komclass/data-event/config'
import PerformanceUser from './components/PerformanceUser.vue'
import Expedition from './components/Expedition.vue'
import HistoryRetur from '../../dashboard-admin-1.1/analitik/ReturArea.vue'
import ChartTransaction from './components/ChartTransaction.vue'

export default {
  components: {
    PerformanceUser,
    Expedition,
    HistoryRetur,
    ChartTransaction,
  },
  async mounted() {
    try {
      // Call fetchData from PerformanceUser and wait for completion
      await this.$refs.performanceUser.getData()

      // Call fetchData from Expdition and wait for completion
      await this.$refs.expedition.loadAllExpeditionData()

      // Call fetchData from chartTransaction and wait for completion
      await this.$refs.chartTransaction.getTransaction()
      await this.$refs.chartTransaction.getChart()
    } catch (error) {
      toastError(error, 'Failed to load dashboard data')
    }
  },
}
</script>
